import React from 'react';
import './ui.css';

/** Field-edition variants: primary (rust), confirm (loden), secondary, ghost, danger, warning, contrast */
export function YButton({ variant = 'primary', size = 'md', block = false, className = '', children, ...rest }) {
  const sizeClass = size === 'sm' ? 'y-btn-sm' : size === 'lg' ? 'y-btn-lg' : '';
  const blockClass = block ? 'y-btn-block' : '';
  return (
    <button className={`y-btn y-btn-${variant} ${sizeClass} ${blockClass} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}

